const inputIdParamName = 'inputId';

export default {
    focusInputFromQueryString,
    inputIdIsPresent
}

export function focusInputFromQueryString() {
    const urlParams = new URLSearchParams(window.location.search)

    if(!inputIdIsPresent()) {
        return;
    }

    const selector = `[input-id="${urlParams.get(inputIdParamName)}"]`;
    const target = document.querySelector(selector) as HTMLElement;

    if(target) {
        target.focus();
    }
}

export function inputIdIsPresent() {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.has(inputIdParamName);
}